import { Typography } from "@mui/material";
import { LabelColors } from "../constants";
import { KVCardRow } from "./CardContent";

export default function DecisionCardContent({ node }) {
  const conditions = node.data.conditions;

  let conditionContent = conditions.map((condition, i) => {
    const comparisons = condition.comparisons;

    let out = comparisons.map((comparison, i) => {
      if (comparison.value.length === 0) {
        comparison.value = '""';
      }

      if (i + 1 === comparisons.length) {
        if (
          comparison.param.length === 0 &&
          comparison.value === '""' &&
          comparison.op === "=="
        ) {
          return (
            <Typography variant="body2" color={"#b5b5b5"}>
              else
            </Typography>
          );
        }

        return (
          <Typography variant="body2" color={"#b5b5b5"}>
            {" "}
            {comparison.param} <b>{comparison.op}</b> {comparison.value}{" "}
          </Typography>
        );
      }
      return (
        <Typography variant="body2" color={"#b5b5b5"}>
          {" "}
          {comparison.param} <b>{comparison.op}</b> {comparison.value}{" "}
          <b>{condition.logic}</b>
        </Typography>
      );
    });

    let ret = (
      <div>
        <span
          style={{
            backgroundColor: LabelColors[i],
            color: "black",
            lineHeight: "1.5",
            borderRadius: "9px",
            fontWeight: "bold",
            fontSize: "12px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
        >
          {i + 1} {condition.customName ? ": " + condition.customName: ''}
        </span>
        {out}
      </div>
    );

    return ret;
  });

  return (
    <div>
      <KVCardRow
        label={"Description"}
        value={node.data.advanced.description}
      ></KVCardRow>
      <Typography variant="subtitle2">Conditions</Typography>
      {conditionContent}
    </div>
  );
}
